import { ArrowRight, Sparkles } from "lucide-react";

const HERO_IMG =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_life-upgrade-hub-2/artifacts/kfyw59wp_IMG_7039_VSCO.webp";

export default function Hero({ onCta }) {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 md:pt-24 pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7 gr-rise">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full gold-outline text-[10px] font-mono tracking-[0.24em] uppercase text-[var(--gold)]">
              <Sparkles size={12} /> Dev Da Don Official Consultation
            </div>
            <h1
              data-testid="hero-headline"
              className="mt-6 font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.95] uppercase text-[var(--text-primary)]"
            >
              Transform your <span className="gold-text">mindset</span>,
              <br />
              <span className="text-[var(--text-primary)]">body</span> &{" "}
              <span className="italic font-serif text-[var(--gold)]">
                style.
              </span>
            </h1>
            <p className="mt-6 text-base sm:text-lg text-[var(--text-secondary)] max-w-xl leading-relaxed">
              Elite consultation across fitness, nutrition, style, mannerism &
              hygiene — engineered so you show up sharper in every room you
              enter.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <button
                data-testid="hero-ai-chat-button"
                onClick={() => onCta && onCta("ai-chat")}
                className="gr-btn-gold px-6 py-3 rounded-full inline-flex items-center gap-2"
              >
                Try AI Consultation <ArrowRight size={16} />
              </button>
              <button
                data-testid="hero-book-now-button"
                onClick={() => onCta && onCta("pricing")}
                className="gr-btn-ghost px-6 py-3 rounded-full inline-flex items-center gap-2"
              >
                View Membership Tiers
              </button>
            </div>

            <div className="mt-12 grid grid-cols-3 gap-4 max-w-xl">
              {[
                { n: "1,500+", l: "Clients Transformed" },
                { n: "98%", l: "VIP Satisfaction" },
                { n: "7", l: "Mastery Pillars" },
              ].map((s) => (
                <div
                  key={s.l}
                  className="border-l border-[var(--border-gold)] pl-4"
                >
                  <div className="font-display text-3xl gold-text">{s.n}</div>
                  <div className="text-xs uppercase tracking-widest text-[var(--text-muted)] mt-1">
                    {s.l}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5 gr-rise" style={{ animationDelay: "120ms" }}>
            <div className="relative rounded-3xl overflow-hidden border border-[var(--border-gold)] aspect-[4/5] max-w-md ml-auto">
              <img
                src={HERO_IMG}
                alt="Dev Da Don"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[var(--bg-primary)] via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5 right-5">
                <div className="eyebrow">The Standard</div>
                <div className="font-display text-2xl mt-1 uppercase">
                  Elevate. Every. Detail.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section-divider max-w-7xl mx-auto" />
    </section>
  );
}
